import {
  Rocket,
  Bug,
  Sparkles,
  Wrench,
  Zap,
  Flame,
  AlertTriangle,
  Shield,
  RefreshCw,
  Palette,
  Gauge,
  Eye,
  CircleDot,
  FileText,
  type LucideIcon,
} from 'lucide-react'

export interface ChangelogEntry {
  id: string
  version: string
  date: string
  time: string
  type: string
  color: string
  title: string
  description: string
  items: string[]
}

export interface ChangelogData {
  entries: ChangelogEntry[]
}

/** Generate KPI-tile style classes from a Tailwind color name. */
export function changelogColorStyle(color: string): string {
  return `bg-${color}-500/10 text-${color}-700 dark:bg-${color}-500/15 dark:text-${color}-300`
}

/** Generate text-only color classes from a Tailwind color name. */
export function changelogTextColor(color: string): string {
  return `text-${color}-600 dark:text-${color}-400`
}

const iconMap: Record<string, LucideIcon> = {
  initial: Rocket,
  launch: Rocket,
  bugfix: Bug,
  fix: Bug,
  feature: Sparkles,
  new: Sparkles,
  improvement: Wrench,
  enhance: Wrench,
  polish: Wrench,
  optimization: Zap,
  perf: Zap,
  performance: Zap,
  hotfix: Flame,
  critical: Flame,
  emergency: Flame,
  breaking: AlertTriangle,
  deprecation: AlertTriangle,
  security: Shield,
  auth: Shield,
  refactor: RefreshCw,
  cleanup: RefreshCw,
  design: Palette,
  ui: Palette,
  ux: Palette,
  accessibility: Eye,
  a11y: Eye,
  test: Gauge,
  ci: Gauge,
  docs: FileText,
}

export function getChangelogIcon(type: string): LucideIcon {
  return iconMap[type.toLowerCase().replace(/\s+/g, '-')] ?? CircleDot
}
